/**!
 * Created by Leonardo Cheslacki on 02/06/2022.
 *
 * MIT License
 *
 * Copyright (c) 2022 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import Big from 'big.js';

import Moment from 'moment';

import 'moment/dist/locale/pt-br';

import MomentFormat from 'moment-duration-format';

Moment.locale('pt-br');

MomentFormat(Moment);

import HelpersCore from './HelpersCore';

import {HelpersForm} from './index';

import config from './../../../../config';

const {default: {domain, routes: {web}, api}} = config;

let _this = {};

class HelpersController extends HelpersCore {
    /**
     *
     */
    constructor() {
        super();
        this.$FormData = (new FormData());
        this.$XMLHttpRequest = (new XMLHttpRequest());
        this.$hours = parseInt(Moment().format('H'));
        this.$month = parseInt(Moment().format('M'));
        this.$day = parseInt(Moment().format('D'));
        this.$timer = {};
        this.$countDown = {};
        this.$countDownMoment = {};
        this.$oClockMoment = {};
        this.$listeners = [];
        this.$controller = {
            timer_delay: 3000,
            big_0: (new Big(0)),
            big_1: (new Big(1)),
            big_2: (new Big(2)),
            big_20: (new Big(20)),
            big_100: (new Big(100)),
            alpha_min: 0,
            alpha_plus: 0.1,
            alpha_max: 1
        };

        _this = this;
    };

    $functionsHelper = {
        /**
         *
         * @param event
         * @param callback
         */
        handleListener: function (event, {callback}) {
            (typeof (callback) === 'function') && callback(event.detail);
        }
    };

    /**
     *
     * @param state
     * @param callback
     */
    setState = (state, callback) => {
        this.state = state;
        (typeof (callback) === 'function') && callback(state);
    };

    /**
     *
     * @param field
     * @returns {string}
     */
    getState = (field) => {
        return this.verifyField(this.state, field, false, null) || this.verifyField(window, `AllTap.state.${field}`, false, null);
    };

    /**
     *
     * @param object
     * @param callback
     */
    setStates = (object, callback) => {
        /**
         *
         * @param state
         * @param object
         * @param callback
         */
        const changeState = (state, object, callback) => {
            if (this.isObjectIf(object)) {
                this.defineObject(object);

                let
                    i = 0,
                    changed = false;

                for (let property in object) {
                    ++i;
                    if (this.inObject(object, property)) {
                        if (this.inObject(state, property) && !this.isArray(state[property]) && !this.isArray(object[property])) {
                            changeState((this.isObject(state[property]) ? state[property] : state), object[property], (value) => {
                                state = {...state, [property]: value};
                                changed = true;
                            });
                        } else if (this.inObject(state, property) && this.isArray(state[property]) && this.isArray(object[property])) {
                            state = {...state, [property]: [...state[property], ...object[property]]};
                            changed = true;
                        } else {
                            state = {...state, [property]: object[property]};
                            changed = true;
                        }

                        if (changed && (object.length === i)) {
                            callback(state);
                        }
                    }
                }
            } else {
                callback(!this.isEmpty(object) ? object : null);
            }
        };

        changeState(this.state, object, (state) => {
            this.setState(state, () => {
                (typeof (callback) === 'function') && callback(true);
            });
        });
    };

    /**
     *
     * @returns {{value: null, on, on, forceUpdate: (function(*))}}
     */
    forceUpdate = () => {
        return {
            value: null,
            get on() {
                return this.value;
            },
            set on(value) {
                this.value = value;
            },
            forceUpdate(string) {
                this.on = string;
            }
        };
    };

    /**
     *
     * @param field
     * @param value
     * @param callback
     */
    mountObject = (field, value, callback) => {
        let
            fields = field.split('.').reverse(),
            object = value;

        this.recursiveSyncMap(fields, 0, fields.length, (item, next) => {
            object = {[item]: object};
            next(true);
        }, () => {
            (typeof (callback) === 'function') && callback(object);
        });
    };

    /**
     *
     * @param alias
     */
    clearThrottle = (alias) => {
        if (this.inObject(this.$timer, alias)) {
            clearTimeout(this.$timer[alias]);
            this.removeObject(this.$timer, alias);
        }
    };

    /**
     *
     * @param alias
     * @param callback
     * @param delay
     */
    throttle = (alias, callback, delay = this.$controller.timer_delay) => {
        this.$timer[alias] && this.clearThrottle(alias);
        this.$timer[alias] = setTimeout(() => {
            (typeof (callback) === 'function') && callback(true);
        }, delay || this.$controller.timer_delay);
    };

    /**
     *
     * @param alias
     */
    clearCountDown = (alias) => {
        if (this.inObject(this.$countDown, alias)) {
            clearInterval(this.$countDown[alias]);
            this.removeObject(this.$countDown, alias);
        }
    };

    /**
     *
     * @param alias
     * @param delay
     * @param time_out
     * @param done
     * @param always
     * @returns {{resume: *, pause: *}}
     */
    countDown = (alias, delay, time_out, done, always = null) => {
        let
            status = true,
            count = time_out;

        if (!this.inObject(this.$countDown, alias)) {
            this.$countDown[alias] = setInterval(() => {
                status && count--;
                if (count < 0) {
                    this.clearCountDown(alias);
                    (typeof (always) === 'function') && always(true);
                } else {
                    done((count < 0) ? 0 : count.toString());
                }
            }, delay);
        }

        return {
            pause: () => {
                status = false;
            },
            resume: () => {
                status = true;
            }
        };
    };

    /**
     *
     * @param alias
     */
    clearCountDownMoment = (alias) => {
        if (this.inObject(this.$countDownMoment, alias)) {
            clearInterval(this.$countDownMoment[alias]);
            this.removeObject(this.$countDownMoment, alias);
        }
    };

    /**
     *
     * @param alias
     * @param delay
     * @param time_out
     * @param done
     * @param always
     * @returns {{resume: *, pause: *}}
     */
    countDownMoment = (alias, delay, time_out, done, always = null) => {
        let
            status = true,
            count = Moment(time_out, 'HH:mm:ss');

        if (!this.inObject(this.$countDownMoment, alias)) {
            this.$countDownMoment[alias] = setInterval(() => {
                status && (count = count.subtract(1, 'seconds'));
                if (count.isBefore(Moment('00:00:00', 'HH:mm:ss'))) {
                    this.clearCountDownMoment(alias);
                    (typeof (always) === 'function') && always(true);
                } else {
                    done(count.isBefore(Moment('00:00:00', 'HH:mm:ss')) ? '00:00:00' : count.format('mm:ss'));
                }
            }, delay);
        }

        return {
            pause: () => {
                status = false;
            },
            resume: () => {
                status = true;
            }
        };
    };

    /**
     *
     * @param alias
     */
    clearOClockMoment = (alias) => {
        if (this.inObject(this.$oClockMoment, alias)) {
            clearInterval(this.$oClockMoment[alias]);
            this.removeObject(this.$oClockMoment, alias);
        }
    };

    /**
     *
     * @param alias
     * @param done
     * @param delay
     */
    getOClockMoment = (alias, done, delay = 1000) => {
        if (!this.inObject(this.$oClockMoment, alias)) {
            this.$oClockMoment[alias] = setInterval(() => {
                done(Moment().format('HH:mm'));
            }, delay);
        }
    };

    /**
     *
     * @param seconds
     * @returns {*}
     */
    getFormatSecondsToTime = (seconds) => {
        let duration = Moment.duration(seconds, 'seconds');
        return duration.format('mm:ss', {trim: false});
    };

    /**
     *
     * @param time
     * @returns {string}
     */
    getFormatMinutes = (time) => {
        return Moment(time, 'HH:mm:ss').format('mm:ss');
    };

    /**
     *
     * @param element
     * @param type
     * @param reference
     * @param listener
     * @param options
     * @param data
     */
    addListener = (element, type, reference, listener, options = false | {}, data = null) => {
        const execute = () => {
            if (this.isElement(element) || this.isXMLHttpRequest(element) || this.isObjectIf(element) || this.isMediaQueryList(element)) {
                if (this.verifyField(options, 'passive')) {
                    options = (Modernizr.passiveeventlisteners ? {passive: true} : false);
                }

                let listenerCall = listener;

                if (this.isObject(data)) {
                    listenerCall = function (event) {
                        listener.call(listener, event, data);
                    }
                    element.addEventListener(type, listenerCall, options);
                } else {
                    element.addEventListener(type, listenerCall, options);
                }

                this.$listeners = [...this.$listeners, ...[{
                    element: element,
                    reference: reference,
                    listener: listenerCall,
                    data: data
                }]];
            }
        };

        if (this.isArrayIf(this.$listeners)) {
            const object = this.getListener(reference);
            !this.isObject(object) && execute();
        } else {
            execute();
        }
    };

    /**
     *
     * @param type
     * @param reference
     * @param callback
     */
    removeListener = (type, reference, callback = null) => {
        if (this.isArrayIf(this.$listeners)) {
            const object = this.getListener(reference);

            if (this.isObject(object)) {
                const
                    element = this.verifyField(object, 'element'),
                    listener = this.verifyField(object, 'listener');

                if (this.isElement(element) || this.isXMLHttpRequest(element) || this.isObjectIf(element) || this.isMediaQueryList(element)) {

                    element.removeEventListener(type, listener);

                    this.$listeners = this.$listeners.filter((value) => {
                        return value.reference !== reference;
                    });
                }
                (typeof (callback) === 'function') && callback(true);
            } else {
                (typeof (callback) === 'function') && callback(true);
            }
        } else {
            (typeof (callback) === 'function') && callback(true);
        }
    };

    /**
     *
     * @param reference
     */
    getListener = (reference) => {
        let array = this.$listeners.filter((value) => {
            return (value.reference === reference);
        });

        return this.isArrayIf(array) && this.firstArray(array);
    };

    /**
     *
     * @param element
     * @param type
     */
    dispatch = (element, type) => {
        element.dispatchEvent(new Event(type));
    };

    /**
     *
     * @param type
     * @param object
     * @param reference
     * @param force
     */
    emit = (type, object = {}, reference = null, force = false) => {
        const {document} = window.top;

        object.current_name = reference;

        document.dispatchEvent(new CustomEvent(type, {detail: object}));
    };

    /**
     *
     * @param type
     * @param callback
     * @param reference
     */
    on = (type, callback, reference = null) => {
        const {document} = window.top;

        reference = this.toSlug((`${type}-${reference || document.baseURI}`));

        this.removeListener(type, reference, () => {
            this.addListener(document, type, reference, this.$functionsHelper.handleListener, false, {callback: callback});
        });
    };

    /**
     *
     * @param element
     * @param name
     * @returns {boolean}
     */
    isElement = (element, name = null) => {
        return Boolean(!this.isEmpty(element)
            && ((typeof (element.nodeType) !== 'undefined')
                && ((element.nodeType === Node.ELEMENT_NODE) || (element.nodeType === Node.DOCUMENT_NODE))
                && (!this.isEmpty(name) ? (element.tagName.toLowerCase() === name.toLowerCase()) : this.isEmpty(name))
            ));
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isElementIf = (element) => {
        return Boolean(this.isElement(element) && ((typeof (element.childNodes) !== 'undefined') && element.childNodes.length));
    };

    /**
     *
     * @param element
     * @param field
     * @returns {boolean}
     */
    inElement = (element, field) => {
        return Boolean(this.isElement(element) && typeof (element[field]) !== 'undefined');
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isNodeElement = (element) => {
        return Boolean(!this.isEmpty(element) && ((typeof (element.nodeType) !== 'undefined') && element.nodeType === Node.ELEMENT_NODE));
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isNodeElementIf = (element) => {
        return Boolean(this.isNodeElement(element) && ((typeof (element.childNodes) !== 'undefined') && element.childNodes.length));
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isNodeText = (element) => {
        return Boolean(!this.isEmpty(element) && ((typeof (element.nodeType) !== 'undefined') && element.nodeType === Node.TEXT_NODE));
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    getNodeValue = (element) => {
        return (this.isNodeText(element) && (typeof (element.nodeValue) !== 'undefined') && !this.isEmpty(element.nodeValue)) ? element.nodeValue : null;
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    getNodeTagName = (element) => {
        return (this.isNodeElement(element) && (typeof (element.tagName) !== 'undefined')) && element.tagName;
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    getNodeAttributes = (element) => {
        return (this.isNodeElement(element) && (typeof (element.attributes) !== 'undefined')) && this.isObjectIf(element.attributes) ? element.attributes : null;
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isNodeAttribute = (element) => {
        return Boolean(!this.isEmpty(element) && ((typeof (element.nodeType) !== 'undefined') && element.nodeType === Node.ATTRIBUTE_NODE));
    };

    /**
     *
     * @param string
     * @param name
     * @returns {boolean}
     */
    hasString = (string, name) => {
        return Boolean(!this.isEmpty(string) && (new RegExp(name)).test(string));
    };

    /**
     *
     * @param element
     * @param name
     * @returns {any|null}
     */
    getNodeAttribute = (element, name) => {
        let attribute = this.verifyField(element, `attributes.${name}`);

        return (this.isNodeAttribute(attribute) && (typeof (attribute.nodeValue) !== 'undefined') && !this.isEmpty(attribute.nodeValue)) ? attribute.nodeValue : null;
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isXMLHttpRequest = (object) => {
        return (this.isObject(object) && ((typeof (object.constructor) !== 'undefined') && ((object.constructor.name === 'XMLHttpRequest') || (object.constructor.name === 'XMLHttpRequestUpload'))));
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isMediaQueryList = (object) => {
        return (this.isObject(object) && ((typeof (object.constructor) !== 'undefined') && (object.constructor.name === 'MediaQueryList')));
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isInteger = (string) => {
        return !this.isEmpty(string) && (/^(\d+)$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isIntegerOrFloat = (string) => {
        return !this.isEmpty(string) && (/^(-)?(\d+)(\.)?(\d+)?$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isIdCompound = (string) => {
        return !this.isEmpty(string) && (/^(\d+)([A-Z])$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isHexColor = (string) => {
        return !this.isEmpty(string) && (/^#([0-9A-F]{6})$/i).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isTintColor = (string) => {
        return !this.isEmpty(string) && (/^0x([0-9A-F]{6})$/i).test(string);
    };

    /**
     *
     * @param string
     * @returns {false|string}
     */
    tintToHex = (string) => {
        return this.isTintColor(string) && `#${string.substring(2).toUpperCase()}`;
    };

    /**
     *
     * @param object
     */
    defineObject = (object) => {
        (this.isObjectIf(object) && !object.hasOwnProperty('length')) && Object.defineProperty(object, 'length', {
            get: () => {
                return Object.keys(object).length;
            }
        });
    };

    /**
     *
     * @param element
     * @returns {*}
     */
    elementToArray = (element) => {
        let array = this.isObjectIf(element) && Array.prototype.slice.call(element);
        return this.isArray(array) ? array : [];
    };

    /**
     * @param {array} array
     * @param {array} weight
     * @param {function(Object.<string, object>)} callback
     */
    randomWeight = (array, weight, callback) => {
        let
            total = eval(weight.join('+')),
            arrayWeight = [],
            current = 0;

        while (current < array.length) {
            for (let i = 0; i < weight[current]; i++) {
                arrayWeight[arrayWeight.length] = {value: array[current], index: current};
                if (total === arrayWeight.length) {
                    (typeof (callback) === 'function') && callback(arrayWeight[Math.floor(Math.random() * total)]);
                }
            }
            current++;
        }
    };

    /**
     *
     * @param array
     * @returns {*}
     */
    shuffleArray = (array) => {
        let currentIndex = array.length, randomIndex;

        while (currentIndex > 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }

        return array;
    };

    /**
     *
     * @param event
     * @returns {boolean}
     */
    stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
        // event.cancelBubble = true;
        // event.returnValue = false;
        return false;
    };

    /**
     *
     * @param _LOCATION_
     * @param _SOURCE_
     * @returns {`${string}//${string}${string}`}
     */
    toUri = (_LOCATION_, _SOURCE_) => {
        return `${_LOCATION_.protocol}//${_LOCATION_.host}${_SOURCE_}`;
    };

    /**
     *
     * @param baseURI
     * @returns {*}
     */
    toSrc = (baseURI) => {
        return baseURI.split('/').slice(0, -1).join('/');
    };

    getIdUri = () => {
        return this.lastArray(location.pathname.split('/'));
    };

    /**
     *
     * @param big_number
     * @param big
     * @param round
     * @returns {*}
     */
    bigToNumber = (big_number, big = false, round = 'default') => {
        switch (round) {
            case 'int':
                big_number = big_number.round();
                break;
            case 'up':
                big_number = big_number.round(1, Big.roundUp);
                break;
            case 'down':
                big_number = big_number.round(1, Big.roundDown);
                break;
            default:
                big_number = big_number.round(2);
                break;
        }

        return big ? big_number : big_number.toNumber();
    };

    /**
     *
     * @param string
     * @returns {false|string}
     */
    toFloat = (string) => {
        return !this.isEmpty(string) && string.toString().replace(/,/g, '.').replace(/[^\d\.-]/g, '');
    };

    /**
     *
     * @param string
     * @returns {*|boolean|number}
     */
    toInteger = (string) => {
        string = this.toFloat(string);
        return this.isIntegerOrFloat(string) && this.bigToNumber(new Big(string), false, 'ind');
    };

    /**
     *
     * @param string
     * @returns {*|boolean|string}
     */
    toIntegerOrFloat = (string) => {
        string = this.toFloat(string);
        return this.isIntegerOrFloat(string) && this.bigToNumber(new Big(string), false, 'up');
    };

    /**
     * Check and refactor
     */

    /**
     *
     * @param number
     * @param length
     * @returns {string}
     */
    padWithLeadingZeros = (number, length) => {
        return String(number).padStart(length, '0').toString();
    };

    /**
     *
     * @param original
     * @param current
     * @param target
     * @param big
     * @param round
     * @returns {*}
     */
    calcSize = (original, current, target, big = false, round = 'default') => {
        let
            big_original = this.inObject(original, 'constructor') ? original : (new Big(original)),
            big_current = this.inObject(current, 'constructor') ? current : (new Big(current)),
            big_target = this.inObject(target, 'constructor') ? target : (new Big(target)),
            big_number = (new Big(this.$controller.big_0));

        /**
         *
         * @param big_original
         * @param big_current
         * @param big_target
         * @returns {*}
         */
        const calcSizeSubtract = (big_original, big_current, big_target) => {
            return big_target.minus(big_target.div(this.$controller.big_100).times(big_original.minus(big_current).div(big_original).times(this.$controller.big_100)));
        };

        /**
         *
         * @param big_original
         * @param big_current
         * @param big_target
         * @returns {*}
         */
        const calcSizeAddition = (big_original, big_current, big_target) => {
            return big_target.plus(big_target.div(this.$controller.big_100).times(big_current.minus(big_original).div(big_original).times(this.$controller.big_100)));
        };

        if (big_original.gte(big_current)) {
            big_number = calcSizeSubtract(big_original, big_current, big_target);
        } else if (big_original.lt(big_current)) {
            big_number = calcSizeAddition(big_original, big_current, big_target);
        }

        return this.bigToNumber(big_number, big, round);
    };

    openFullScreen = () => {
        const element = window.top.document.documentElement;
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) { /* Safari */
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { /* IE11 */
            element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {/* Firefox */
            element.mozRequestFullScreen();
        }
    };

    closeFullScreen = () => {
        const document = window.top.document;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {/* Firefox */
            document.mozCancelFullScreen();
        }
    };

    /**
     *
     * @param string
     * @param separator
     * @returns {string}
     */
    toSlug = (string, separator = '-') => {
        const sets = [
            {to: 'A', from: '[ÀÁÂÃÄÅĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
            {to: 'a', from: '[àáâãäåāăąạảấầẩẫậắằẳẵặª]'},
            {to: 'AE', from: '[Æ]'},
            {to: 'ae', from: '[æ]'},
            {to: 'C', from: '[ÇĆĈČ]'},
            {to: 'c', from: '[çćĉč]'},
            {to: 'D', from: '[ÐĎĐÞ]'},
            {to: 'd', from: '[ðďđþ]'},
            {to: 'E', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
            {to: 'e', from: '[èéêëēĕėęěẹẻẽếềểễệ]'},
            {to: 'G', from: '[ĜĞĢǴ]'},
            {to: 'g', from: '[ĝğģǵ]'},
            {to: 'H', from: '[ĤḦ]'},
            {to: 'h', from: '[ĥḧ]'},
            {to: 'I', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
            {to: 'i', from: '[ìíîïĩīįi̇ỉị]'},
            {to: 'J', from: '[Ĵ]'},
            {to: 'j', from: '[ĵ]'},
            {to: 'IJ', from: '[Ĳ]'},
            {to: 'ij', from: '[ĳ]'},
            {to: 'K', from: '[Ķ]'},
            {to: 'k', from: '[ķ]'},
            {to: 'L', from: '[ĹĻĽŁ]'},
            {to: 'l', from: '[ĺļľł]'},
            {to: 'M', from: '[Ḿ]'},
            {to: 'm', from: '[ḿ]'},
            {to: 'N', from: '[ÑŃŅŇ]'},
            {to: 'n', from: '[ñńņň]'},
            {to: 'O', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
            {to: 'o', from: '[òóôõöøōŏőọỏốồổỗộớờởỡợǫǭơº]'},
            {to: 'OE', from: '[Œ]'},
            {to: 'oe', from: '[œ]'},
            {to: 'P', from: '[Ṕ]'},
            {to: 'p', from: '[ṕ]'},
            {to: 'R', from: '[ŔŖŘ]'},
            {to: 'r', from: '[ŕŗř]'},
            {to: 'S', from: '[ŚŜŞŠ]'},
            {to: 's', from: '[śŝşš]'},
            {to: 'SS', from: '[ẞ]'},
            {to: 'ss', from: '[ß]'},
            {to: 'T', from: '[ŢŤ]'},
            {to: 't', from: '[ţť]'},
            {to: 'U', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
            {to: 'u', from: '[ùúûüũūŭůűųụủứừửữựư]'},
            {to: 'W', from: '[ẂŴẀẄ]'},
            {to: 'w', from: '[ẃŵẁẅ]'},
            {to: 'X', from: '[Ẍ]'},
            {to: 'x', from: '[ẍ]'},
            {to: 'Y', from: '[ÝŶŸỲỴỶỸ]'},
            {to: 'y', from: '[ýŷÿỳỵỷỹ]'},
            {to: 'Z', from: '[ŹŻŽ]'},
            {to: 'z', from: '[źżž]'},
            {to: '-and-', from: '[&]'},
            {to: '-', from: '[_]'}
        ];

        string = string.toString().trim();

        sets.forEach((set) => {
            string = string.replace(new RegExp(set.from, 'g'), set.to);
        });

        string = string.split(/(?=[A-Z])/).join('-').toLowerCase();

        string = string.replace(/\s+/g, '-')  /* Replace spaces with - */
            .replace(/[^\w-]/g, '')           /* Remove all non-word chars */
            .replace(/-+/g, '-')              /* Replace multiple - with single - */
            .replace(/^-+/, '')               /* Trim - from start of text */
            .replace(/-+$/, '');
        /* Trim - from end of text */

        if ((typeof (separator) !== 'undefined') && (separator !== '-')) {
            string = string.replace(/-/g, separator);
        }

        return string;
    };

    /**
     *
     * @param string
     * @param length
     * @param is_break
     * @returns {string}
     */
    toCapitalize = (string, length = 3, is_break = true) => {
        !this.isEmpty(string) && (string = this.removeSpaceDuplicate(string.toString()).toLowerCase().trim());

        let array = string.split(new RegExp(/\s+/g));

        for (let i = 0; i < array.length; i++) {
            (array[i].length > length || i === 0) && (array[i] = (`${array[i].charAt(0).toUpperCase()}${array[i].slice(1)}`).trim());

            (new RegExp(/%n/g)).test(array[i]) && (array[i] = array[i].replace('%n', (is_break ? '\n' : ' ')));
        }

        return array.join(' ');
    };

    /**
     *
     * @param string
     * @returns {string}
     */
    firstToUpper = (string) => {
        !this.isEmpty(string) && (string = this.removeSpaceDuplicate(string));
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    /**
     *
     * @param string
     * @returns {string}
     */
    firstToLower = (string) => {
        !this.isEmpty(string) && (string = this.removeSpaceDuplicate(string));
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    /**
     *
     * @param string
     * @returns {string}
     */
    toClassName = (string) => {
        !this.isEmpty(string) && (string = string.replace(/_+/g, ' '));
        return this.toCapitalize(string, 0).replace(/\s+/g, '');
    };

    /**
     *
     * @param string
     * @param prefix
     * @returns {`_handle${string}`}
     */
    toHandleName = (string, prefix = null) => {
        !this.isEmpty(prefix) && (string = `${prefix}_${string}`);
        return `_handle${this.toClassName(string)}`;
    };

    /**
     *
     * @param string
     * @returns {boolean|*}
     */
    toNumber = (string) => {
        !this.isEmpty(string) && (string = Number(string.toString().replace(/\D/g, '')));
        return (typeof (string) === 'number') && string;
    };

    /**
     *
     * @param string
     * @returns {boolean|*}
     */
    toName = (string) => {
        !this.isEmpty(string) && (string = String(string.toString().replace(/[^a-z]/g, '')));
        return (typeof (string) === 'string') && string;
    };

    /**
     *
     * @param string
     * @returns {boolean|*}
     */
    toRawLower = (string) => {
        !this.isEmpty(string) && (string = string.toString().replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
        return (typeof (string) === 'string') && string;
    };

    /**
     *
     * @param string
     * @returns {boolean|String}
     */
    removeSpaceDuplicate = (string) => {
        return Boolean(string) && string.replace(/\s+/g, ' ');
    };

    /**
     *
     * @param string
     * @returns {boolean|String}
     */
    removeAllSpace = (string) => {
        return Boolean(string) && string.replace(/\s+/g, '');
    };

    /**
     *
     * @param name
     * @returns {boolean}
     */
    removeArrayInput = (name) => {
        return Boolean(name) && name.replace(/\[]$/, '');
    };

    /**
     *
     * @param name
     * @returns {boolean}
     */
    checkArrayInput = (name) => {
        return Boolean(name) && (/\[]$/).test(name);
    };

    /**
     *
     * @param name
     * @returns {boolean}
     */
    checkArrayNamedInput = (name) => {
        return Boolean(name) && (/\[(.*?)]/g).test(name);
    };

    /**
     *
     * @param name
     * @returns {*}
     */
    extractArrayNamedInput = (name) => {
        return Boolean(name) && name.match(/\[(.*?)]/g);
    };

    /**
     *
     * @param name
     * @returns {*}
     * @constructor
     */
    ArrayNamedToNameInput = (name) => {
        let array = Boolean(name) && name.match(/\w+/g);
        if (this.isArrayIf(array)) {
            return array[0];
        }
    };

    /**
     *
     * @param data
     * @param filed
     * @returns {*}
     */
    getError = (data, filed) => {
        const array = this.verifyField(data, filed);
        if (this.isArrayIf(array)) {
            return array[0];
        }
    };

    /**
     *
     * @param id
     * @returns {false|HTMLElement}
     */
    getElementById = (id) => {
        const {document} = window.top;

        let element = document.getElementById(id);

        if (this.isElement(element)) {
            /**
             *
             * @param element
             * @returns {(function(*): (*|undefined))|*}
             */
            const wantDisabled = (element) => (disabled = false) => {
                element.setAttribute('style', `display: ${disabled ? 'none' : 'block'}`);
            };

            element.wantDisabled = wantDisabled(element);
        }

        return this.isElement(element) && element;
    };

    /**
     *
     * @param element
     * @param attributes
     */
    setAttributes = (element, attributes = {}) => {
        if (this.isElement(element) && this.isObjectIf(attributes)) {
            for (let property in attributes) {
                element.setAttribute(this.toSlug(property), attributes[property]);
            }
        }
    };

    /**
     *
     * @param name
     * @param paginate
     * @returns {string}
     */
    getUriSource = (name, paginate = null) => {
        return `${this.$base_uri || domain}/${web.uri_src}/${name}/${paginate || name}.html`
    };

    /**
     *
     * @param name
     * @returns {`${string|string}/public/images/${string}`}
     */
    getUriImage = (name) => {
        return `${this.$base_uri || domain}/${web.uri_images}/${name}`;
    };

    /**
     *
     * @param name
     * @returns {`${string|string}/public/css/${string}`}
     */
    getUriCss = (name) => {
        return `${this.$base_uri || domain}/${web.uri_css}/${name}`;
    };

    /**
     *
     * @param name
     * @returns {`${string|string}/${*}/${string}`}
     */
    getUriJs = (name) => {
        return `${this.$base_uri || domain}/${web.uri_js}/${name}`;
    };

    /**
     *
     * @param uri
     * @param data
     * @param objectResponse
     */
    getForm = (uri, data, objectResponse) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'GET', action: uri}, type: 'xml'}));

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setHeaders(api.ajax_setup_headers);

        helpersForm.submit();
    };

    /**
     *
     * @param uri
     * @param data
     * @param objectResponse
     */
    postForm = (uri, data, objectResponse) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'POST', action: uri}, type: 'json'}));

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setHeaders(api.ajax_setup_headers);

        helpersForm.setToJsonData(data, helpersForm.submit);
    };

    /**
     *
     * @param element
     * @returns {*[]|{}}
     */
    xmlToJson = (element) => {
        let object = [] || {};

        if (this.isElementIf(element)) {
            for (let property of element.childNodes) {
                if (this.isNodeText(property) && this.getNodeValue(property)) {
                    object = {
                        [this.getNodeTagName(property.parentNode)]: {
                            attributes: this.getNodeAttributes(property.parentNode),
                            value: this.getNodeValue(property)
                        }
                    };
                }

                if (this.isNodeElementIf(property)) {
                    let temp = this.xmlToJson(property);

                    if (this.isObjectIf(temp)) {
                        object[this.getNodeTagName(property.parentNode)] = {...object[this.getNodeTagName(property.parentNode)], ...temp};
                    } else if (this.isArrayIf(temp)) {
                        object.push({
                            [this.getNodeTagName(property)]: temp,
                            attributes: this.getNodeAttributes(property)
                        });
                    } else {
                        object.push({...temp, attributes: this.getNodeAttributes(property)});
                    }
                }
            }
        }

        return object;
    };

    /**
     *
     * @param event
     */
    setDirection = (event) => {
        let
            pageX = ((typeof (event.nativeEvent) !== 'undefined') ? event.nativeEvent.pageX : event.pageX),
            pageY = ((typeof (event.nativeEvent) !== 'undefined') ? event.nativeEvent.pageY : event.pageY);

        if (pageX && pageY) {
            if (pageX < this.state.temp_pageX) {
                this.state.direction_x = 'left'
            } else if (pageX > this.state.temp_pageX) {
                this.state.direction_x = 'right'
            }

            if (pageY < this.state.temp_pageY) {
                this.state.direction_y = 'up'
            } else if (pageY > this.state.temp_pageY) {
                this.state.direction_y = 'down'
            }

            this.state.temp_pageX = pageX;
            this.state.temp_pageY = pageY;
        }
    };
}

export default HelpersController;
